import React from "react";
import type { Plan } from "@/data/billing/plans";

type Props = {
  plan: Plan;
  onSelect: (code: string) => void;
  disabled?: boolean;
};

export default function PlanCard({ plan, onSelect, disabled }: Props) {
  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-700 p-5 flex flex-col justify-between">
      <div>
        <div className="text-sm uppercase tracking-wider text-gray-500">Plan</div>
        <div className="mt-1 text-lg font-medium">{plan.name}</div>
        {plan.tagline && <p className="mt-2 text-sm text-gray-600">{plan.tagline}</p>}
        {plan.features && plan.features.length > 0 && (
          <ul className="mt-4 list-disc pl-5 text-sm text-gray-600 space-y-1">
            {plan.features.map((f) => (
              <li key={f}>{f}</li>
            ))}
          </ul>
        )}
      </div>
      <div className="mt-5">
        <button
          onClick={() => onSelect(plan.code)}
          disabled={disabled}
          className="w-full inline-flex items-center justify-center rounded-full bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-600 px-5 py-2 text-white tracking-wider uppercase text-sm hover:scale-[1.02] transition disabled:opacity-60"
        >
          {disabled ? "Redirecting…" : `Choose ${plan.name}`}
        </button>
      </div>
    </div>
  );
}
